import React from 'react';
import { string, number, bool, shape } from 'prop-types';
import classnames from 'classnames';
import StyledLabel from '../../styled-label';
import Thermometer from '../../seller-data/components/status/thermometer';

const namespace = 'ui-vip-seller-rank';

const SellerRank = ({ className = '', rank, is_thermometer_large, seller_status_info, thermometer_id }) => (
  <div className={classnames(className, namespace)}>
    <div
      className={classnames(`${namespace}__rank-container`, {
        [`${namespace}__thermometer-large`]: is_thermometer_large,
      })}
    >
      {seller_status_info?.title && <StyledLabel {...seller_status_info.title} className={`${namespace}__rank-text`} />}
      <div className={`${namespace}__thermometer-container`}>
        <Thermometer thermometer_id={thermometer_id} rank={rank} is_large={is_thermometer_large} />
      </div>
    </div>
    <StyledLabel {...seller_status_info?.subtitle} className={`${namespace}__subtitle`} />
  </div>
);

SellerRank.propTypes = {
  className: string,
  rank: number.isRequired,
  is_thermometer_large: bool.isRequired,
  seller_status_info: shape({
    title: shape({}),
    subtitle: shape({}).isRequired,
  }).isRequired,
  thermometer_id: string.isRequired,
};

export default SellerRank;
